<template>
    <table class="table table-sm">
        <thead>
        <tr>
            <th>Name</th>
            <th>Location</th>
        </tr>
        </thead>
        <tbody>
        <template v-if="!wayPoints.length">
            <tr><td rowspan="3" class="text-danger">No waypoints added</td><td v-if="editable"></td></tr>
        </template>
        <template v-else>
            <tr v-for="wayPoint in wayPoints" v-bind:key="wayPoint.name">
                <td>{{wayPoint.name}}</td>
                <td v-html="renderLocationAsLink(wayPoint.location)"></td>
                <td v-if="editable" ><a href="#" data-toggle="tooltip" title="Delete waypoint" @click.prevent="deleteWayPoint(wayPoint.name)"><font-awesome-icon :icon="['fas', 'times-circle']" class="red"></font-awesome-icon></a></td>
            </tr>
        </template>
        </tbody>
    </table>
</template>

<script>

    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {renderLocationAsLink} from "../../utils/formatters";

    export default {
        components: {FontAwesomeIcon},
        name: "WayPointsTable",
        props: {
            wayPoints: Array,
            deleteWayPoint: Function,
            editable: Boolean
        },
        methods: {
            renderLocationAsLink,
        }
    }
</script>

<style scoped>

</style>
